<template>
    <div class="chatbot-container ">
        <div v-if="!showFAQSection" class="chatbot-header">
            <div class="header-title">{{ $t('Contact us') }}</div>
            <div class="header-subtitle">{{ $t('Choose the appropriate contact method') }}</div>
        </div>

        <transition name="fade" mode="out-in">
            <div v-if="!showFAQSection" class="contact-options">
                <div class="contact-option" @click="callHotline">
                    <div class="option-icon phone-icon">
                        <img src="@/assets/images/a.svg" alt="Phone" class="custom-icon">
                    </div>
                    <div class="option-text">
                        {{ $t('Hotline') }}
                    </div>
                </div>

                <div class="contact-option" @click="chatWhatsapp">
                    <div class="option-icon whatsapp-icon">
                        <img src="@/assets/images/chatbot2.svg" alt="WhatsApp" class="custom-icon">
                    </div>
                    <div class="option-text">{{ $t('Chat Whatsapp') }}</div>
                </div>

                <div class="contact-option" @click="showFAQ">
                    <div class="option-icon faq-icon">
                        <img src="@/assets/images/chatbot3.svg" alt="FAQ" class="custom-icon">
                    </div>
                    <div class="option-text">{{ $t('Frequently Asked Questions') }}</div>
                </div>
            </div>

            <div v-else class="faq-section">
                <div class="faq-header">
                    <div class="back-button" @click="closeFAQ">
                        <img src="@/assets/images/chatbot4.svg" alt="Back" class="custom-icon-small">
                    </div>
                    <div class="faq-title">{{ $t('FreqAskQs') }}</div>
                </div>

                <!-- Add FAQ list with scroll detection -->
                <div class="faq-list" ref="faqList" @scroll="handleScroll">
                    <div v-if="faqs.length === 0 && !isLoading" class="no-data">
                    </div>

                    <div v-for="(faq, index) in faqs" :key="index" class="faq-item"
                        :class="{ 'faq-item-open': faq.isOpen }" @click="toggleFAQ(index)">
                        <div class="faq-question">
                            {{ faq.question }}
                            <img v-if="!faq.isOpen" src="@/assets/images/chatbot6.svg" alt="Expand"
                                class="custom-icon-small">
                            <img v-else src="@/assets/images/chatbot5.svg" alt="Collapse" class="custom-icon-small">
                        </div>
                        <div v-if="faq.isOpen" class="faq-answer">
                            {{ faq.answer }}
                        </div>
                    </div>

                    <div v-if="isLoading" class="loading-indicator loading-indicator-active">
                        {{ $t('Loading...') }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import service from '../../services/MobileService'
// eslint-disable-next-line no-unused-vars
import LocalStorage from '@/ultils/local-storage'

export default {
    name: 'Chatbot',
    data() {
        return {
            showFAQSection: false,
            allFaqsLoaded: false, // Thay đổi thành false để kích hoạt phân trang
            searchQuery: '',
            currentPage: 1,
            isLoading: false,
            maxPage: null,
            faqs: [],
            whatapp: '',
            hotline: ''
        }
    },
    computed: {
        filteredFaqs() {
            if (!this.searchQuery) return this.faqs;
            const query = this.searchQuery.toLowerCase();
            return this.faqs.filter(faq =>
                faq.question.toLowerCase().includes(query) ||
                faq.answer.toLowerCase().includes(query)
            );
        },
        displayedFaqs() {
            // If searching, show all filtered FAQs
            if (this.searchQuery) return this.filteredFaqs;

            // Otherwise, show paginated FAQs
            return this.filteredFaqs.slice(0, this.pageSize * this.currentPage);
        }
    },

    created() {
        // this.loadData();
        this.getHotLineAndWhatApps();
    },

    methods: {

        async loadData() {
            try {
                console.log('Current Page:', this.currentPage, 'Max Page:', this.maxPage);
                this.isLoading = true;
                if (this.maxPage && this.currentPage > this.maxPage) {
                    this.allFaqsLoaded = true;
                    return;
                }

                console.log('Calling ptg_getAllQuestionSupport with params:', {
                    Page: this.currentPage,
                    Limit: 10,
                    channel: 'myunitel'
                });
                
                const response = await service.ptg_getAllQuestionSupport({
                    Page: this.currentPage,
                    Limit: 10,
                    Channel: 'myunitel'  // Add channel field
                });
                
                console.log('ptg_getAllQuestionSupport response:', response);

                // Xử lý response đúng cấu trúc từ API
                if (response && response.errorCode === '0') {
                    const data = response.wsResponse.data || [];
                    const totalItems = response.wsResponse.totalItem || 0;
                    
                    console.log('Total items:', totalItems, 'Current faqs length:', this.faqs.length);
                    
                    if (!this.maxPage) {
                        // Calculate maxPage based on the Limit we're using (10)
                        this.maxPage = Math.ceil(totalItems / 10);
                        console.log('Max page calculated:', this.maxPage);
                    }

                    // Map dữ liệu theo đúng cấu trúc API trả về
                    const mappedData = data.map(item => ({
                        question: item.question || '',
                        answer: item.answer || '',
                        isOpen: false
                    }));

                    this.faqs.push(...mappedData);
                    this.currentPage++;
                    
                    // Only set allFaqsLoaded to true when we've loaded all items
                    this.allFaqsLoaded = this.faqs.length >= totalItems;
                    console.log('All FAQs loaded:', this.allFaqsLoaded, 'faqs.length:', this.faqs.length);
                }
            } catch (error) {
                console.error('Failed to load FAQ data:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async getHotLineAndWhatApps() {
            try {
                this.isLoading = true;

                const response = await service.ptg_getListAppParams({
                    "code": [
                        "hotline_myunitel",
                        "whatapps_myunitel"
                    ],
                });

                if (response && response.errorCode === '0') {
                    const data = response.wsResponse || [];

                    // Tìm object theo từng code
                    const whatsappItem = data.find(item => item.code === 'whatapps_myunitel');
                    const hotlineItem = data.find(item => item.code === 'hotline_myunitel');

                    // Parse value từ JSON string -> object, sau đó lấy content.en
                    if (whatsappItem?.value) {
                        const whatsappValue = JSON.parse(whatsappItem.value);
                        this.whatapp = whatsappValue?.content?.en;
                    }

                    if (hotlineItem?.value) {
                        const hotlineValue = JSON.parse(hotlineItem.value);
                        this.hotline = hotlineValue?.content?.en;
                    }
                    this.whatapp = this.whatapp || 'https://wa.me/message/ZMTUJ6C3CJMRO1';
                    this.hotline = this.hotline || '209349999';

                }

            } catch (error) {
                console.error('Failed to load FAQ data:', error);
            } finally {
                this.isLoading = false;
            }
        },

        handleScroll(event) {
            // Don't trigger if already loading or all FAQs loaded
            if (this.allFaqsLoaded) return;

            const element = event.target;
            // Check if user has scrolled to the bottom (with a small threshold)
            if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
                // Set loading flag
                this.isLoading = true;

                // Debounce the loadData call
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }

                this.scrollTimeout = setTimeout(() => {
                    this.loadData().finally(() => {
                        this.isLoading = false;
                    });
                }, 300); // Wait 300ms before loading more data
            }
        },

        async loadMoreFaqs() {
            // Don't load more if already loading or all FAQs are loaded
            if (this.isLoading || this.allFaqsLoaded || this.searchQuery) return;

            this.isLoading = true;

            // Simulate loading delay (remove this in production if not needed)
            await new Promise(resolve => setTimeout(resolve, 500));

            this.currentPage++;

            // Check if we've loaded all FAQs
            if (this.pageSize * this.currentPage >= this.filteredFaqs.length) {
                this.allFaqsLoaded = true;
            }

            this.isLoading = false;
        },

        callHotline() {
            // Check if it's a mobile device
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

            if (isMobile) {
                // On mobile, create a direct call link
                window.location.href = 'tel:' + this.hotline;
            } else {
                // On desktop, show an alert
                this.$store.dispatch('setNotification', { content: this.$t('hotline_message', { phone: this.hotline }) })

                // alert(this.$t('hotline_message', { phone: this.hotline }));
            }
        },

        // chatWhatsapp() {
        //     // Implement WhatsApp chat functionality
        //    // window.open(this.whatapp, '_blank');
        //     window.location.href = this.whatapp;
        // },
        chatWhatsapp() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isAndroid = /android/i.test(userAgent);

            if (isAndroid) {
                window.open(this.whatapp, '_blank');
            } else {
                window.location.href = this.whatapp;
            }
        },

        showFAQ() {
            this.loadData();
            this.showFAQSection = true;
        },
        closeFAQ() {
            this.showFAQSection = false;
            this.clearSearch();
        },
        toggleFAQ(index) {
            // Create a copy of the faqs array
            const updatedFaqs = [...this.faqs];
            // Toggle the isOpen property of the selected FAQ
            updatedFaqs[index].isOpen = !updatedFaqs[index].isOpen;
            // Update the faqs array
            this.faqs = updatedFaqs;
        },
        clearSearch() {
            this.searchQuery = '';
        },
        closeChat() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.chatbot-container {
    width: 350px;
    max-width: 100%;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 140px;
    right: 20px;
    z-index: 1000;
    font-family: "Noto Sans JP", sans-serif;
    font-weight: 500;
}

@keyframes smooth-bounce-in {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.chatbot-header {
    background-color: #F6601B;
    color: white;
    padding: 12px 20px;
    text-align: left;
}

.header-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    padding-left: 9px;
    font-family: "Noto Sans JP", sans-serif;
}

.header-subtitle {
    font-size: 12px;
    font-weight: 400;
    padding-left: 9px;
    font-family: "Noto Sans JP", sans-serif;
}

.contact-options {
    padding: 15px 20px;
    background-color: #FFECD3;
}

.contact-option {
    width: 307px;
    height: 48px;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 12px;
    margin-bottom: 12px;
    cursor: pointer;
    background-color: white;
    transition: transform 0.3s, background-color 0.3s, box-shadow 0.3s;
    min-height: 46px;
    width: 100%;
    box-sizing: border-box;
}

.contact-option:hover {
    background-color: #f5f5f5;
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}

.option-icon {
    width: 30px;
    height: 30px;
    margin-right: 15px;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;
}

.contact-option:hover .option-icon {
    transform: scale(1.12) rotate(3deg);
    transition: transform 0.7s cubic-bezier(0.25, 1, 0.5, 1);
}

.option-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
    font-family: 'Noto Sans JP', sans-serif;
}

img.custom-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.custom-icon-small {
    width: 12px;
    height: 12px;
    object-fit: contain;
    margin: 3px;
    display: block;
}

.faq-section {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.faq-header {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: white;
    color: #333;
    position: relative;
    border-bottom: 1px solid #ffffff;
    margin-top: 10px;
}

.faq-title {
    font-size: 16px;
    font-weight: 700;
    margin-left: 10px;
    font-family: 'Noto Sans JP', sans-serif;
    color: #333;
}

.back-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 18px;
    margin-top: 5px;
    transition: transform 0.3s ease;
    background-color: transparent;
    border-radius: 50%;
    box-shadow: none;
}

.back-button:hover {
    transform: translateX(-3px);
}

.faq-list {
    padding: 3px 10px;
    overflow-y: auto;
    max-height: 380px;
    flex-grow: 1;
    background-color: white;
    margin-top: 5px;
}

.faq-item {
    background-color: white;
    padding: 15px 15px !important;
    overflow: hidden;
    box-shadow: none;
    border-bottom: 1px solid #eee !important;
    transition: background-color 0.3s ease;
    cursor: pointer !important;
    margin-bottom: 10px !important;
}

.faq-item-open {
    background-color: #f5f5f5;
    border-radius: 12px;
}

.faq-question {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-weight: 700;
    color: #333;
    font-size: 14px;
    line-height: 1.3;
    padding-right: 10px;
    gap: 10px;
    font-family: 'Noto Sans JP', sans-serif;
}

.faq-answer {
    padding: 8px;
    margin-top: 5px;
    color: #666;
    line-height: 1.3;
    font-size: 14px;
    background-color: transparent;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    max-height: 500px;
    overflow: hidden;
    font-family: 'Noto Sans JP', sans-serif;
}

.loading-indicator {
    text-align: center;
    padding: 10px;
    border-radius: 12px;
    font-size: 14px;
    color: #666;
    background-color: #f5f5f5;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.5s ease, transform 0.5s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.loading-indicator-active {
    opacity: 1;
    transform: translateY(0);
}
</style>
